export const Debug = {
    enabled: false,

    log() {
        if (this.enabled) {
            console.log.apply(this, arguments);
        }
    }
};


// WEBPACK FOOTER //
// ./src/js/application/Debug.js